var React = require("react");
var OidcManager = require('../../Auth/oidcManager.js').default;
var oAuthConstants = require('../../Auth/oAuthConstants.js');
var UrlUtils = require('../../utils/urlUtils');
var IFrameManager = require('../../Auth/IFrameManager/iFrameManager.js').default;

class LoginPrefSilentAuth extends React.Component {
    constructor(props) {
        super(props);
        this._oidcManager = new OidcManager(oAuthConstants);
        this._iFrameManager = IFrameManager();
        this._handleAuth = this.handleAuth.bind(this);
    }
    componentDidMount() {
        console.log("window.location : ", window.location)
        this._handleAuth();
    }

    handleAuth() {
        const code = UrlUtils.getParameterByName("code", window.location.href);
        if (code) {
            //store session_state in cookie so can be used while check_session_iframe
            // UrlUtils.saveCookie(oAuthConstants.sessionStateKey, UrlUtils.getParameterByName("session_state", window.location.href));
            //SSO TODO Remove from localstorage
            localStorage.setItem(oAuthConstants.sessionStateKey, UrlUtils.getParameterByName("session_state", window.location.href)); //Local

            //Start the silent login process
            this._oidcManager.silentNotify(code)
                .then(() => {
                    console.log("successfully got the access token");
                })
                .catch((err) => {
                    console.log("Error while getting access token: ", err);
                    //Notify parent with error received to redirect user back to target application
                    this._iFrameManager.notifyParent(err);
                });
        }
        else {
            //No code found in response from authorize request in redirect_uri
            console.log("No code in auth response");
            //create err object with from error and error_description parameters from response from authorize request 
            var err = {
                error: UrlUtils.getParameterByName("error", window.location.href),
                error_description: UrlUtils.getParameterByName("error_description", window.location.href)

            }
            //Notify parent with error received to redirect user back to target application
            this._iFrameManager.notifyParent(err);
        }
    }

    render() {
        return (
            <div></div>
        )
    }
}

module.exports = LoginPrefSilentAuth;